import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Output } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import { environment } from 'environment-configurations';
import * as i3 from 'app-services-library';

class APIPdfView {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    generatePDF(visaType, caseType, caseId, letterType, payload) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/letter/${letterType}/generate/pdf`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    generateI140PDF(superTaskId, caseId, letterType, payload) {
        return this.httpClient.post(`/task/${superTaskId}/case/${caseId}/letter/${letterType}/generate/pdf`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
APIPdfView.ɵfac = function APIPdfView_Factory(t) { return new (t || APIPdfView)(i0.ɵɵinject(i1.HttpClient)); };
APIPdfView.ɵprov = i0.ɵɵdefineInjectable({ token: APIPdfView, factory: APIPdfView.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIPdfView, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BasePdfViewLibraryService {
    constructor(store, apiService, appServicesLibraryService) {
        this.store = store;
        this.apiService = apiService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.redirectionComponent = new EventEmitter();
        this.observableSubscription$ = new Subject();
        this.disabledControls = false;
        this.pdfSrc = '';
    }
    loadInit() {
    }
    ngAfterViewInit() {
        this.documentTemplateId = sessionStorage.getItem('documentTemplateId');
        this.letterType = sessionStorage.getItem('typeOfLetter');
        if (sessionStorage.getItem('wizardTID')) {
            this.generatePDF();
        }
        else {
            // Get Specific step details by passing step code
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
                this.stepDetails = data;
                this.generatePDF();
                this.toggleControlsStatus();
            });
        }
    }
    generatePDF() {
        if (this.inputData.caseType === 'I140') {
            this.apiService.generateI140PDF(this.inputData.superTaskId, this.inputData.caseId, this.letterType, {
                templateId: parseInt(sessionStorage.getItem('documentTemplateId'))
            }).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response) {
                    let dataSlice = response.data['fileLocation'].split('/var/imagility/uploads/');
                    this.pdfSrc = environment.docs + dataSlice[1];
                }
            });
        }
        else {
            this.apiService.generatePDF(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.letterType, {
                templateId: parseInt(sessionStorage.getItem('documentTemplateId'))
            }).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response) {
                    let dataSlice = response.data['fileLocation'].split('/var/imagility/uploads/');
                    this.pdfSrc = environment.docs + dataSlice[1];
                }
            });
        }
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    backLink() {
        sessionStorage.setItem('backFromPreview', 'true');
        this.redirectionComponent.emit("LetterPreview");
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BasePdfViewLibraryService.ɵfac = function BasePdfViewLibraryService_Factory(t) { return new (t || BasePdfViewLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APIPdfView), i0.ɵɵinject(i3.AppServicesLibraryService)); };
BasePdfViewLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BasePdfViewLibraryService, factory: BasePdfViewLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BasePdfViewLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APIPdfView }, { type: i3.AppServicesLibraryService }]; }, { redirectionComponent: [{
            type: Output
        }] }); })();

/*
 * Public API Surface of base-pdf-view-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIPdfView, BasePdfViewLibraryService };
//# sourceMappingURL=base-pdf-view-library.js.map
